/**
 * Derive the warning threshold percentage from policy tiers.
 * Uses the first tier's absence threshold converted to a percentage,
 * or defaults to 80% if no tiers exist.
 */
export function deriveWarningThreshold(totalSessions, tiers) {
    if (tiers.length === 0 || totalSessions === 0)
        return 80;
    const sorted = [...tiers].sort((a, b) => a.absenceThreshold - b.absenceThreshold);
    const firstThreshold = sorted[0].absenceThreshold;
    // Convert absence threshold to attendance percentage
    const thresholdPercentage = ((totalSessions - firstThreshold) / totalSessions) * 100;
    return thresholdPercentage;
}
/**
 * Compute the recovery path — how many sessions must be attended
 * to return to safe territory.
 */
export function computeRecoveryPath(totalSessions, attendedSessions, remainingSessions, warningThreshold) {
    // No remaining sessions → recovery is impossible
    if (remainingSessions === 0) {
        return {
            sessionsNeeded: Infinity,
            targetPercentage: warningThreshold,
            projectedPercentage: totalSessions > 0
                ? (attendedSessions / totalSessions) * 100
                : 100,
            isRecoverable: false,
        };
    }
    // How many sessions must be attended to reach the warning threshold?
    const targetAttended = Math.ceil((warningThreshold / 100) * totalSessions);
    const sessionsNeeded = Math.max(0, targetAttended - attendedSessions);
    // Projected percentage if all remaining sessions are attended
    const projectedPercentage = ((attendedSessions + remainingSessions) / totalSessions) * 100;
    const isRecoverable = projectedPercentage >= warningThreshold;
    return {
        sessionsNeeded,
        targetPercentage: warningThreshold,
        projectedPercentage: Math.min(100, projectedPercentage),
        isRecoverable,
    };
}
//# sourceMappingURL=recoveryPath.js.map